export default function USInstallation() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="20" viewBox="0 0 24 20" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.5 4.3335H21.2647C21.9469 4.3335 22.5 4.85583 22.5 5.50016V17.1668C22.5 17.8112 21.9469 18.3335 21.2647 18.3335H2.73529C2.05306 18.3335 1.5 17.8112 1.5 17.1668V4.3335Z"
                stroke="#3F68E0"
                strokeWidth="1.75"
            />
            <path d="M1.5 2.5835V4.3335" stroke="#3F68E0" stroke-width="1.75" />
            <path d="M16.6667 8.4165V11.3332" stroke="#3F68E0" strokeWidth="1.4" strokeLinecap="round" />
            <rect x="1.5" y="4.3335" width="21" height="14" rx="1.16667" stroke="#3F68E0" strokeWidth="1.3" />
            <path
                d="M1.5 2.5835C1.5 1.617 2.2835 0.833496 3.25 0.833496H15.5C16.1443 0.833496 16.6667 1.35583 16.6667 2.00016V4.3335H3.25C2.2835 4.3335 1.5 3.54999 1.5 2.5835V2.5835Z"
                stroke="#3F68E0"
                strokeWidth="1.6"
            />
        </svg>
    );
}
